import React, { useRef, useState, useEffect } from "react";
import { Spin, Select, Input, message, Modal, Button, Form } from "antd";
import { SearchOutlined, LoginOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DoubleleftSvg from '@/img/doubleleft.png';
import { useSelector } from "react-redux";
import OpenData from '@/components/open-data/open-data';
import api from '@/apis/pc/conversation/conversation';
import apiConversation from "@/apis/pc/conversation/conversation";
import { getParameterByName } from "@/utils/utils";
import userApi from '@/apis/pc/user/user'
import _ from 'lodash';
const { Option } = Select;
const { Search } = Input;

const Wrapper = styled.div`
  width: ${(props) => props.active ? '304px' : '88px'};
  border-right: 1px solid #E8EBF6;
  overflow-y: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-box{
    padding: 24px;
    padding-bottom: 10px;
    width: 100%;
  }
  .search-box-hidden{
    padding: 32px 36px 27px;
    cursor: pointer;
  }
  .tab-box{
    display: flex;
    color: #767B9E;
    margin: 0 24px;
    justify-content: space-between;
    border-bottom: 1px solid #E8EBF6;
    align-items: center;
    position: relative;
    .tab-item{
      flex: none;
      cursor: pointer;
      padding-bottom: 14px;
      padding-top: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #767B9E;
      line-height: 20px;
    }
    .tab-item-active{
      color: var(--ant-primary-color);
      position: relative;
      &::after{
        content: '';
        width: 100%;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: var(--ant-primary-color);
      }
    }
    .tab-item-refresh{
      color: var(--ant-primary-color);
      cursor: pointer;
      font-size: 16px;
    }
    .ant-input-affix-wrapper{
      border-color: #E8EBF6;
      border-radius: 4px;
    }
    .action-box{
      padding: 8px 2px 8px 1px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #E8EBF6;
      position: absolute;
      right: -24px;
      top: 9px;
      height: 30px;
      flex: none;
      cursor: pointer;
      display: flex;
      img{
        width: 14px;
        height: 14px;
      }
    }
  }
  .tab-box-hidden{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    .tab-item-refresh{
      color: var(--ant-primary-color);
      cursor: pointer;
      font-size: 16px;
    }
    .action-box{
      padding: 8px 2px 8px 1px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #E8EBF6;
      position: absolute;
      right: 0px;
      top: 0px;
      height: 30px;
      flex: none;
      cursor: pointer;
      display: flex;
      img{
        width: 14px;
        height: 14px;
      }
    }
  }
  .user-box-hidden{
    overflow-y: auto;
    margin-top: 8px;
    .user-item-active{
      background: rgba(252,131,82,0.1);
    }
    .user-item{
      margin-top: 8px;
      padding: 8px 0px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover{
        background: rgba(252,131,82,0.1);
      }
      .user-icon{
        width: 40px;
        height: 40px;
        border-radius: 4px;
        flex: none;
      }
      .user-message{
        width: 32px;
        height: 18px;
        line-height: 18px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E8EBF6;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #130928;
        flex: none;
        right: 8px;
        top: -2px;
        position: absolute;
      }
    }
  }
  .user-box{
    overflow-y: auto;
    .user-item-active{
      background: rgba(252,131,82,0.1);
    }
    .user-item{
      display: flex;
      align-items: center;
      padding: 8px 24px;
      margin-top: 8px;
      cursor: pointer;
      &:hover{
        background: rgba(252,131,82,0.1);
      }
      .user-icon{
        width: 40px;
        height: 40px;
        border-radius: 4px;
        flex: none;
        margin-right: 8px;
      }
      .user-content{
        flex: 1;
        overflow: hidden;
        .user-content-top{
          line-height: 20px;
          display: flex;
          align-items: center;
          .user-name{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #130928;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .user-label{
            margin-left: 4px;
            padding 0 4px;
            border-radius: 4px;
            background: #E5F1FE;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #52A5FC;
            flex: none;
          }
          .user-leave{
            background: #EBECF1;
            color: #9A9EBA;
          }
        }
        .user-dep{
          margin-top: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #9A9EBA;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .user-message{
        width: 32px;
        height: 18px;
        line-height: 18px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E8EBF6;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #130928;
        flex: none;
        margin-left: 2px;
      }
    }
  }
`;

const CovSearchUserList = (props) => {
  console.log(props, 'props')
  const { isGroup, groupId, uid, wxUserid, customerId, uidList } = props;
  const [sessionList, setSessionList] = useState([])
  const [showAll, setShowAll] = useState(false); // 是否展示全部
  const [searchInput, setSearchInput] = useState(''); // 搜索关键词
  const [loading, setLoading] = useState(false); // 是否加载
  const currentUser = useSelector((state) => state.userInfo.userInfo); // 当前登录用户信息
  const [list, setList] = useState([]); // 当前查看的用户数据
  const [currentData, setCurrentData] = useState(null); // 当前查看的用户
  const [activeTab, setActiveTab] = useState('all');
  const userStautsList = [{value: '全部存档员工', key: 'all'},{value: '在职员工', key: '1'},{value: '离职员工', key: '2'}]
  const condition = useRef({ name: '', pageNum: 1, pageSize: 50, hasNextPage: true }); // 搜索条件
  const isInit = useRef(true);
  const paramRef = useRef({});

  // 切换分类
  const changeTab = (key) => {
    setActiveTab(key);
  }

  const getData = async (isInit) => {
    setLoading(true)
    let params = condition.current;
    params.appSource = 2;
    userApi.getCovUsers([], params).then(res => {
      let data = res.data || [];
      let arr = [];
      data?.forEach(item => {
        // 已离职
        const commonInfo = {
          id: item.uid,
          name: item.name,
          company: item.corpName,
          avatarUrl: item.avatarUrl,
          openWxUserid: item.openWxUserid,
        }
        // 不再需要分类
        arr.push({...item, ...commonInfo});
      })
      setLoading(false)
      setList(arr);
      console.log(arr, 'temptemptemp')
      if (isInit) {
        setCurrentData(arr[0]);
      }
      // condition.current.hasNextPage = data?.length === condition.current.pageSize;
    })
  };
  

  const getUserList = () => {
    setLoading(true);
    if (!isGroup) {
      paramRef.current = {
        extendUserId: wxUserid,
        searchNameParam: '',
        type: 1,
        chatType: 1,
        pageNum: 1,
        pageSize: 100,
        customerDetailFlag: false,
        // 企微客户看的是 客户 与公司销售之间的会话,extendUserType 1 是客户 2 是员工
        extendUserType: 1,
      }
      // api.getSessionId(paramRef.current).then(res => {
        // let findUsers = res?.data?.list?.map(item => item?.uid)
        // 选中人后从人的uid匹配res?.data?.list中的某一条 获取到sessionId
        // setSessionList(res?.data?.list || [])
        // if(findUsers?.length === 0) {
        //   findUsers = [-1]
        // }
        let params = {};
        params.appSource = 2;
        userApi.getCovUsers(uidList, params)
          .then((res) => {
            const userListData = res?.data;
            console.log(userListData, 'userListDatauserListDatauserListData')
            let arr = [];
            userListData?.forEach(item => {
              // 已离职
              const commonInfo = {
                id: item.uid,
                name: item.name,
                company: item.corpName,
                avatarUrl: item.avatarUrl,
                openWxUserid: item.openWxUserid,
              }
              // 不再需要分类
              arr.push({...item, ...commonInfo});
            })
            setList(arr);
            console.log(arr, 'temptemptemp')
            setCurrentData(arr[0]);
          })
          .finally(() => {
            setLoading(false);
          });
      // });
      return;
    } else if (groupId) {
      return
      paramRef.current = {
        groupId,
        chatType: 2,
        pageNum: 1,
        pageSize: 10,
        type: 1,
        extendUserType: 1,
      }
      api.externalGroupList({
          groupId,
          chatType: 2,
          pageNum: 1,
          pageSize: 10,
          type: 1,
          extendUserType: 1,
        })
        .then((res) => {
          if (res.success) {
            if (!res?.data?.list?.[0]) {
              setChatLog({ list: [] });
              return;
            }
            getMessageApi({
              sessionId: res?.data?.list?.[0]?.sessionId,
              messageType: 1,
              pageSize: 30,
              pageType: 1,
              pageNum: 1,
              uid: window?.current_user?.uid || 5536806,
            });
          } else {
            setChatLog({ list: [] });
          }
        }).finally(() => {
          setLoading(false)
        });
    }
  };

  useEffect(() => {
    if((wxUserid && !isGroup) || isGroup) {
      getUserList()
    }
  }, [wxUserid, isGroup])

  useEffect(() => {
    if (_.get(currentData, 'id', '')) {
      props.onChange && props.onChange(currentData);
    }
  }, [currentData])
  return (
    <Wrapper active={showAll}>
      <>
        <div className="user-box-hidden scroll-style">
          {
            list.map(item => {
              return (
                <div className={`user-item ${item.id === _.get(currentData, 'id', '') ? 'user-item-active' : ''}`} key={item.id} onClick={() => {
                  setCurrentData(item);
                }}
>
                  <img className="user-icon" src={item.avatarUrl} alt="" />
                  <div className="user-message">{
                        item.thirdChatMsgCount ?
                        Number(item.thirdChatMsgCount) > 99 ? 
                          '99+' :
                          item.thirdChatMsgCount :
                        '暂无'
                      }</div>
                </div>
              );
            })
          }
        </div>
      </>
    </Wrapper>
  );
};

export default CovSearchUserList;